export default __webpack_public_path__ + "static/media/screen5.8e7c39e8.png";